import {
  type Component,
  ComponentType,
  DataType,
  Layout,
} from '@vgtv/api-client/lib/component';

import { CategorySplash } from '../Splash/CategorySplash/CategorySplash';
import { AssetSplash } from '../Splash/AssetSplash/AssetSplash';
import { Carousel } from '../Carousel/Carousel';

import { VerticalAssetsList } from './components/VerticalAssetList/VerticalAssetsList';
import { HorizontalAssetsList } from './components/HorizontalAssetList/HorizontalAssetsList';
import { AssetsSlider } from './components/AssetsSlider/AssetsSlider';
import { CategoriesSlider } from './components/CategoriesSlider/CategoriesSlider';
import { CategoriesList } from './components/CategoriesList/CategoriesList';
import { AssetsEditorial } from './components/AssetsEditorial/AssetsEditorial';
import { ProfilesSlider } from './components/ProfilesSlider/ProfilesSlider';
import { AssetsFilteredList } from './components/AssetsFilteredList/AssetsFilteredList';
import { CustomSplash } from './components/CustomSplash/CustomSplash';
import { StayliveStreamsSlider } from './components/StayliveStreamsSlider/StayliveStreamsSlider';
import { LiveSchedule } from './components/LiveSchedule/LiveSchedule';
import { SeasonsSlider } from './components/SeasonsSlider/SeasonsSlider';
import { ContinueWatchingWrapper } from './components/ContinueWatching/ContinueWatchingWrapper';
import { MixedSlider } from './components/MixedSlider/MixedSlider';
import { MixedList } from './components/MixedList/MixedList';
import {
  type CardSliderComponent,
  CardsSlider,
} from './components/CardsSlider/CardsSlider';
import { StoriesSlider } from './components/StoriesSlider/StoriesSlider';

/**
 * returns correct PageComponent based on type and configuration of component
 * and its data source
 */
function getPageComponent(componentConfig: Component | CardSliderComponent) {
  const {
    type,
    options,
    data: { type: dataType, preset } = {},
  } = componentConfig;

  const hasPreset = preset && preset.length > 0;

  if (type === ComponentType.LIST && dataType === DataType.ASSETS) {
    if (options && options.layout === Layout.HORIZONTAL) {
      return HorizontalAssetsList;
    }
    return VerticalAssetsList;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.SEASONS) {
    return SeasonsSlider;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.ASSETS) {
    return AssetsSlider;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.MIXED) {
    return MixedSlider;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.STORIES) {
    return StoriesSlider;
  }

  if (type === ComponentType.LIST && dataType === DataType.MIXED) {
    return MixedList;
  }

  if (
    type === ComponentType.CONTINUE_WATCHING &&
    dataType === DataType.ASSETS
  ) {
    return ContinueWatchingWrapper;
  }

  if (type === ComponentType.LIST && dataType === DataType.CATEGORIES) {
    return CategoriesList;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.CATEGORIES) {
    return CategoriesSlider;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.PROFILES) {
    return ProfilesSlider;
  }

  if (type === ComponentType.EDITORIAL && dataType === DataType.ASSETS) {
    return AssetsEditorial;
  }

  if (type === ComponentType.LIVE_ASSETS_SCHEDULE) {
    return LiveSchedule;
  }

  if (
    type === ComponentType.SPLASH &&
    dataType === DataType.CATEGORIES &&
    hasPreset
  ) {
    return CategorySplash;
  }

  if (
    type === ComponentType.SPLASH &&
    dataType === DataType.ASSETS &&
    hasPreset
  ) {
    return AssetSplash;
  }

  if (type === ComponentType.SPLASH && !hasPreset) {
    return CustomSplash;
  }

  if (type === ComponentType.CAROUSEL) {
    return Carousel;
  }

  if (type === ComponentType.FILTERED_LIST) {
    return AssetsFilteredList;
  }

  if (type === ComponentType.SLIDER && dataType === DataType.STAYLIVE_STREAMS) {
    return StayliveStreamsSlider;
  }

  if (type === ComponentType.SLIDER && dataType === 'cards') {
    return CardsSlider;
  }

  // This is required to fake that this component accepts componentConfig
  return (props: any) => null;
}

export { getPageComponent };
